import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { mainLine } from '@/mocks/jiuchou-architecture';

export default function Positioning() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="核心定位"
            title="九畴云铺 · 乡村数字经济操作系统"
            subtitle="以 TOMA 智能体为智能入口，以数字货架为商业载体，以 ePin 为数据底座，以数字消费为应用场景，以智能清分和产业协同形成可复制的县域数字商业基础设施。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
            {[
              { icon: 'ri-robot-2-line', name: 'TOMA 智能体', tag: '智能入口' },
              { icon: 'ri-store-2-line', name: '数字货架', tag: '商业载体' },
              { icon: 'ri-qr-code-line', name: 'ePin', tag: '数据底座' },
              { icon: 'ri-red-packet-line', name: '数字消费', tag: '应用场景' },
              { icon: 'ri-flow-chart', name: '智能清分', tag: '产业协同' },
            ].map((t) => (
              <div
                key={t.name}
                className="p-5 rounded-lg bg-background-100 border border-background-200 text-center"
              >
                <div className="w-11 h-11 mx-auto rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className={`${t.icon} text-primary-600 text-xl`}></i>
                </div>
                <div className="mt-3 font-heading font-bold text-foreground-950 text-sm">{t.name}</div>
                <div className="mt-1 text-xs text-foreground-500">{t.tag}</div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div className="mt-10">
            <div className="text-center text-xs font-medium text-foreground-500 mb-4">
              一条业务主线
            </div>
            <div className="flex flex-wrap justify-center items-center gap-2">
              {mainLine.map((m, i) => (
                <div key={m.zh} className="flex items-center gap-2">
                  <div className="px-4 py-2 rounded-md bg-background-100 border border-background-200 text-center">
                    <div className="font-heading font-bold text-foreground-950 text-sm">{m.zh}</div>
                    <div className="text-[10px] text-foreground-400">{m.en}</div>
                  </div>
                  {i < mainLine.length - 1 && (
                    <i className="ri-arrow-right-line text-primary-500 text-sm"></i>
                  )}
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}